export enum ModalType {
  EXTRA_SMALL = 'extraSmall',
  SMALL = 'small',
  SMALL_PLUS = 'smallPlus',
  MEDIUM = 'medium',
  MEDIUM_PLUS = 'mediumPlus',
  LARGE = 'large',
  EXTRA_LARGE = 'extraLarge',
}
